import { render, staticRenderFns } from "./RelatedRedazione.vue?vue&type=template&id=6729b595"
import script from "./RelatedRedazione.vue?vue&type=script&lang=js"
export * from "./RelatedRedazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports